module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    on: {
      "click": function($event) {
        _vm.$emit('select')
      }
    }
  }, [_c('v-card-media', {
    staticClass: "text-xs-center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100px",
      "max-height": "100px",
      "margin": "20px"
    },
    attrs: {
      "src": _vm.provider.Logo
    }
  })]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "white"
  }, [_c('span', [_vm._v(_vm._s(_vm.provider.Name))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("compare_arrows")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b038af8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProfileProviderCard.vue
// module id = 336
// module chunks = 2